<template>
  <div class="home-box flex flex-d ai-c">
    <img src="@/assets/animation/anbgnew.jpg" alt="" class="bgImg">
    <img src="@/assets/animation/titleOne.png" alt="" class="oneTitle allPosition">
    <img src="@/assets/animation/titleTwo11.png" alt="" class="twoTitle allPosition">
    <div class="threeTitle allPosition">弦镜—星图数据旗下的一款电商数据搜索工具，最懂用户需求的大数据分析平台。</div>
    <div class="flex ai-c jc-c btnOne allPosition" @click="goDownLoad">立即体验</div>
    <div class="iconOne allPosition"></div>
    <div class="titleFour allPosition">快</div> 
    <div class="titleFive allPosition">即时搜索，高效便捷随时随地搜到想要看到的行业、品牌、店铺、宝贝情况。</div>
    <div class="iconOne zhunOne allPosition"></div>
    <div class="titleFour zhunTwo allPosition">准</div> 
    <div class="titleFive zhunThree allPosition">通过星图数据自主研发的大数据系统，对互联网电商平台数据进行实时监控、清洗处理、整合，并进行可视化呈现。</div>
    <div class="iconOne quanOne allPosition"></div>
    <div class="titleFour quanTwo allPosition">全</div> 
    <div class="titleFive quanThree allPosition">海内外数十个电商平台，上千个行业，上万个细分品类，数据应有尽有。</div>
    <img src="@/assets/animation/wordOne.png" alt="" class="wordOne allPosition">
    <img src="@/assets/animation/wordTwo.png" alt="" class="wordTwo allPosition">
    <img src="@/assets/animation/wordThree.png" alt="" class="wordThree allPosition">
    <img src="@/assets/animation/wordFour.png" alt="" class="wordFour allPosition">
    <div class="titleSix allPosition">提供您关注的行业在全平台市场真实客观的长期规模及趋势变化。帮助您清晰的查看到行业规模与增速，明确品牌竞争格局，为战略布局提供决策依据。</div>
    <div class="titleSeven allPosition">使用场景</div>
    <div class="scene allPosition">
      <div class="mainDiv">
        <div class="mainTitle">洞察市场趋势</div>
        <div class="mainContentOne">通过行业与子行业规模与增速数据的清晰呈现，帮助您快速了解行业趋势与品类销售情况。</div>
        <div class="mainContentTwo">解决痛点：<br>现有数据不足以看清行业现状与市场竞争格局，无法判断未来趋势。</div>
        <img src="@/assets/animation/sceneOne.png" alt="" class="mainImg">
      </div>
      <div class="mainDiv">
        <div class="mainTitle">跟踪竞品表现</div>
        <div class="mainContentOne">通过查看竞品销售情况、热销宝贝分布、热销店铺情况，充分了解竞品动态，及时调整策略，保持核心竞争优势。</div>
        <div class="mainContentTwo">解决痛点：<br>无法深入了解竞品销售数据、评论情况。</div>
        <img src="@/assets/animation/sceneTwo.png" alt="" class="mainImg">
      </div>
      <div class="mainDiv">
        <div class="mainTitle">发现潜力产品赛道</div>
        <div class="mainContentOne">清晰查看行业爆品宝贝和新品宝贝增长趋势。挖掘特征卖点，打造行业爆款</div>
        <div class="mainContentTwo">解决痛点：<br>不了解新兴行业及产品，无法有效、高成功率打造爆款</div>
        <img src="@/assets/animation/sceneThree.png" alt="" class="mainImg">
      </div>
      <div class="mainDiv mainDivLast">
        <div class="mainTitle">快速选品</div>
        <div class="mainContentOne">通过品牌、品类、宝贝排行榜功能，直观查看销额TOP榜单，快速明确选品方向，为业务赋能。</div>
        <div class="mainContentTwo">解决痛点：<br>电商选品不贴合用户需求，无法有效、高效的选品。</div>
        <img src="@/assets/animation/sceneFour.png" alt="" class="mainImg">
      </div>
    </div>
    <div class="titleEight allPosition">关于我们</div>
    <div class="titleDesc allPosition">弦镜（Synlen），是星图数据（Syntun）于2021年推出的电商数据搜索工具，依托于星图数据（Syntun）自主研发的先进技术，通过快速搜索行业信息、品牌信息、店铺信息、宝贝信息等功能为商家和专业研究人士提供全球电商数据，是各界人士必备的生意决策利器。</div>
    <!-- <div class="codeDiv allPosition flex ai-c jc-c">
      <div class="codeOne flex flex-d ai-c jc-c">
        <img src="@/assets/animation/codeOne.jpg" alt="" class="imgCode">
        <div @click="goDownLoad" style="cursor: pointer;">"弦镜"APP下载</div>
      </div>
      <div class="codeTwo flex flex-d ai-c jc-c">
        <img src="@/assets/animation/codeTwo.jpg" alt="" class="imgCode">
        <div>"弦镜"抖音号</div>
      </div>
    </div> -->
    <div class="footDiv allPosition flex flex-d ai-c jc-c">
      <div class="footOne flex">
        <div class="ys" @click="goYszc">隐私政策</div>
        <div class="fenge">｜</div>
        <div class="ys" @click="goQxlb">权限列表</div>
        <div class="fenge">｜</div>
        <div class="ys" @click="goVersion">版本管理</div>
      </div>
      <div class="footTwo">北京星图数网科技有限公司</div>
      <div class="footTwo">京ICP备14010051号-7</div>
      <div class="footThree flex ai-c" @click="goBa">
        <img src="@/assets/animation/security-icon.png" alt="" class="imgBa">
        <div>京公网安备 11030102010826号</div>
      </div>
    </div>
    <Overlay :show="show" @click="show = false">
      <div class="wrapper">
        <img class="logo" src="@/assets/goDown.png">
      </div>
      <div class="goDownTitle">1.点击右上角"..."</div>
      <div class="goDownTitle">2.选择"在浏览器中打开"</div>
    </Overlay>
    <div class="floatingWindow flex" @click="goDownLoad">
      <img class="downImg" src="@/assets/down.png">
    </div>
  </div>
</template>

<script>
import { Overlay } from 'vant';
export default {
  name: 'carrousel',
  data() {
    return {
      show: false,
    }
  },
  components: {
    Overlay
  },
  mounted () {
    this.init();
  },
  computed: {},
  methods: {
    //动画初始化
    init(){
      const targetAll = document.querySelectorAll('.allPosition');
      //初始化一个实例
      var observer = new IntersectionObserver(changes => {
        //change.target 是被监听的元素 当前可视区域正在变化的元素
        //change.intersectionRect 目标元素与视口（或根元素）的交叉区域的信息
        //change.intersectionRatio 目标元素与视口（或根元素）的交叉区域的占比 完全可见时为1，完全不可见时小于等于0
        //change.boundingClientRect 目标元素与视口（或根元素）的交叉区域的信息 目标元素的矩形区域的信息
        //change.rootBounds 视口（或根元素）的矩形区域的信息 根元素的矩形区域信息，即为getBoundingClientRect方法返回的值
        //change.time 当可视状态变化时，状态发送改变的时间戳 对比时间为，实例化的时间 比如，值为1000时，表示在IntersectionObserver实例化的1秒钟之后，触发该元素的可视性变化
        for (const change of changes) {
          // 在视图里面出现的时候设置动画
          if(change.intersectionRatio){
            //判断是哪个元素，添加不同的动画
            if(change.target.className.indexOf('oneTitle') != -1){
              change.target.classList.add('animate__animated', 'animate__fadeInUp');
              change.target.addEventListener('animationend', () => {
                // 第一个动画结束后执行第二个动画
                change.target.classList.remove('animate__animated', 'animate__fadeInUp');
                change.target.classList.add('animate__animated', 'animate__rubberBand');
              });
            }else if(change.target.className.indexOf('twoTitle') != -1 || change.target.className.indexOf('titleFive') != -1){
              change.target.classList.add('animate__animated', 'animate__fadeInUp');
            }else if(change.target.className.indexOf('threeTitle') != -1 || change.target.className.indexOf('iconOne') != -1 || change.target.className.indexOf('titleSeven') != -1 || change.target.className.indexOf('titleEight') != -1){
              change.target.classList.add('animate__animated', 'animate__lightSpeedInLeft');
            }else if(change.target.className.indexOf('btnOne') != -1 || change.target.className.indexOf('titleFour') != -1){
              change.target.classList.add('animate__animated', 'animate__lightSpeedInRight');
            }else if(change.target.className.indexOf('wordOne') != -1){
              change.target.classList.add('animate__animated', 'animate__fadeInTopLeft');
            }else if(change.target.className.indexOf('wordTwo') != -1){
              change.target.classList.add('animate__animated', 'animate__fadeInTopRight');
            }else if(change.target.className.indexOf('wordThree') != -1){
              change.target.classList.add('animate__animated', 'animate__fadeInBottomLeft');
            }else if(change.target.className.indexOf('wordFour') != -1){
              change.target.classList.add('animate__animated', 'animate__fadeInBottomRight');
            }else if(change.target.className.indexOf('titleSix') != -1){
              change.target.classList.add('animate__animated', 'animate__swing');
            }else if(change.target.className.indexOf('titleDesc') != -1){
              change.target.classList.add('animate__animated', 'animate__jackInTheBox');
            }else if(change.target.className.indexOf('codeDiv') != -1 || change.target.className.indexOf('scene') != -1){
              change.target.classList.add('animate__animated', 'animate__zoomIn');
            }
            //动画完成就移除监听
            observer.unobserve(change.target);
          }
        }
      }, {});
      // 对元素target添加监听，当target元素变化时，就会触发上述的回调
      targetAll.forEach((item,index)=>{
        observer.observe(item);
      })
    },
    //去下载
    goDownLoad(){
      var u = navigator.userAgent;
      var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      var isAndroid= u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      //u.toLowerCase().match(/MicroMessenger/i) == "micromessenger" //微信自带的浏览器打开
      if(isIos){
        //ios
        // console.log('ios浏览器')
        if(u.toLowerCase().match(/MicroMessenger/i) == "micromessenger"){
          //微信自带的浏览器打开
          this.show=true;
          // window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.syntun.synlen';
        }else{
          window.location.href = 'https://apps.apple.com/cn/app/id1601918648';
        }
      }else if(isAndroid){
        //安卓
        // console.log('安卓浏览器')
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.syntun.synlen';
      }
    },
    //打开新页面跳转隐私政策
    goYszc(){
      window.open("http://yinsi.synlen.com/");
    },
    //打开新页面跳转权限列表
    goQxlb(){
      window.open("http://yinsidown.synlen.com/");
    },
    //跳转备案
    goBa(){
      window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11030102010826");
    },
    //跳转版本管理页面
    goVersion(){
      this.$router.push({path:'/versionManagement'});
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
.home-box {
  overflow-x: hidden;
  position: relative;
  font-family: 'Source Han Sans CN';
  .bgImg {
    width: 100%;
    height: 100%;
  }
  .allPosition{
    position: absolute;
    left: 84px;
  }
  .oneTitle{
    top: 246px;
    width: 250px;
    height: 110px;
    cursor: pointer;
  }
  .twoTitle{
    top: 400px;
    width: 570px;
    height: 48px;
    cursor: pointer;
  }
  .threeTitle{
    top: 621px;
    width: 576px;
    cursor: pointer;
    font-size: 32px;
    font-weight: 400;
    color: #999999;
    text-align: left;
    line-height: 48px;
  }
  .btnOne{
    top: 846px;
    width: 280px;
    height: 70px;
    background: url("~@/assets/animation/btnBg.png") no-repeat;
    background-size: 100% 100%;
    text-align: center;
    line-height: 70px;
    color: #fff;
    font-size: 32px;
    font-weight: 400;
  }
  .iconOne{
    top: 1052px;
    width: 98px;
    height: 98px;
    background: linear-gradient(50deg, #121050, #377AF0);
    opacity: 0.4;
    border-radius: 50%;
  }
  .titleFour{
    top: 1093px;
    left: 118px;
    width: 57px;
    height: 56px;
    font-size: 60px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 48px;
  }
  .titleFive{
    top: 1237px;
    width: 576px;
    height: 78px;
    font-size: 32px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 48px;
    text-align: justify;
    left: 50%;
    margin-left: -288px;
  }
  .zhunOne{
    top: 1459px;
  }
  .zhunTwo{
    top: 1501px;
  }
  .zhunThree{
    top: 1635px;
    height: 127px;
  }
  .quanOne{
    top: 1905px;
  }
  .quanTwo{
    top: 1947px;
  }
  .quanThree{
    top: 2088px;
  }
  .wordOne{
    top: 2408px;
    left: 317px;
    width: 58px;
    height: 64px;
  }
  .wordTwo{
    top: 2408px;
    left: 380px;
    width: 58px;
    height: 64px;
  }
  .wordThree{
    top: 2466px;
    left: 317px;
    width: 58px;
    height: 64px;
  }
  .wordFour{
    top: 2466px;
    left: 380px;
    width: 58px;
    height: 64px;
  }
  .titleSix{
    top: 2635px;
    width: 567px;
    height: 175px;
    font-size: 32px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 48px;  
    text-align: justify;
  }
  .titleSeven,.titleEight{
    top: 3003px;
    left: 275px;
    width: 200px;
    height: 45px;
    font-size: 48px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 48px;
  }
  .scene{
    top: 3142px;
    left: 0;
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;
    .mainDiv{
      width: 501px;
      height: 950px;
      background: url("~@/assets/animation/divbg.png") no-repeat;
      background-size: 100% 100%;
      display: inline-block;
      margin-left: 83px;
      text-align: center;
      padding: 80px 34px;
      color: #fff;
      box-sizing: border-box;
      .mainTitle{
        font-size: 40px;
        font-weight: 400;
        line-height: 48px;
      }
      .mainContentOne{
        margin-top: 60px;
      }
      .mainContentOne,.mainContentTwo{
        height: 200px;
        font-size: 28px;
        font-weight: 400;
        text-align: justify;
        white-space: normal;
      }
      .mainImg{
        width: 100%;
        height: 302px;
      }
    }
    .mainDivLast{
      margin-right: 83px;
    }
  }
  .titleEight{
    top: 4330px;
  }
  .titleDesc{
    top: 4469px;
    left: 91px;
    width: 567px;
    height: 267px;
    font-size: 27px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 48px;
    text-align: justify;
  }
  .codeDiv{
    top: 4883px;
    left: 0;
    width: 100%;
    .codeOne,.codeTwo{
      color: #fff;
      font-size: 24px;
      font-weight: 400;
      margin: 0 30px;
      .imgCode{
        width: 207px;
        height: 207px;
        margin-bottom: 20px;
      }
    }
  }
  .footDiv{
    top: 5030px;
    left: 0;
    width: 100%;
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    .footOne,.footTwo,.footThree{
      margin-bottom: 20px;
    }
    .footOne{
      .ys{
        cursor: pointer;
      }
      .fenge{
        margin: 0 20px;
      }
    }
    .footThree{
      cursor: pointer;
      .imgBa{
        width: 30px;
        height: 30px;
      }
    }
  }
  .floatingWindow{
    width: 100px;
    height: 100px;
    position: fixed;
    right: 0;
    bottom: 30vh;
    .downImg{
      width: 100%;
      height: 100%;
    }
  }
}
//下载
.wrapper{
  text-align: right;
  padding: 0 10px;
  .logo{
    width: 250px;
    margin: 40px;
  }
}
.goDownTitle{
  width: 100%;
  text-align: left;
  color: #fff;
  font-size: 60px;
  padding: 0 30px;
}
</style>